import { useEffect, useState } from 'react';

const ANNOUNCEMENTS = [
  {
    title: 'Upcoming challenge',
    detail: 'STEM Quest opens Monday · earn extra credits',
    accent: 'accent-green',
    tag: 'New',
  },
  {
    title: 'New course drop',
    detail: 'AI Storytelling elective now live · enroll today',
    accent: 'accent-purple',
    tag: 'Hot',
  },
  {
    title: 'Upgrade your app',
    detail: 'v1.4 adds offline notes & focus timer',
    accent: 'accent-blue',
    tag: 'Update',
  },
];

export default function Announcements() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setCurrent((prev) => (prev + 1) % ANNOUNCEMENTS.length);
    }, 5000);
    return () => clearInterval(id);
  }, []);

  const active = ANNOUNCEMENTS[current];

  return (
    <div className="widget-card">
      <p className="eyebrow">Announcements</p>
      <div className="announcement-carousel" role="status" aria-live="polite">
        <article key={active.title} className={`flash-card ${active.accent}`}>
          <span className="flash-tag">{active.tag}</span>
          <h4>{active.title}</h4>
          <p>{active.detail}</p>
        </article>
        <div className="carousel-dots">
          {ANNOUNCEMENTS.map((item, index) => (
            <button
              key={item.title}
              type="button"
              className={`dot ${index === current ? 'active' : ''}`}
              onClick={() => setCurrent(index)}
              aria-label={`Show announcement: ${item.title}`}
              aria-pressed={index === current}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
